import { render, staticRenderFns } from "./time.vue?vue&type=template&id=6fdaab28&scoped=true&"
import script from "./time.vue?vue&type=script&lang=js&"
export * from "./time.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fdaab28",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/brisk/brisk-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6fdaab28')) {
      api.createRecord('6fdaab28', component.options)
    } else {
      api.reload('6fdaab28', component.options)
    }
    module.hot.accept("./time.vue?vue&type=template&id=6fdaab28&scoped=true&", function () {
      api.rerender('6fdaab28', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/fields/input/time.vue"
export default component.exports